<template>
  <div class="row">

    <div class="col-md-4">
      <select2
          :options="operatorList"
          :displayLabel="false"
          size="sm"
          :model.sync="operatorLocal"
          :clearable="false"
          :disabled="isOperatorDisabled"
          label="i18n"
      />
    </div>

    <div class="col-md-8">
      <select2
          :options="autocompleteEmployees"
          label="_display"
          reduce="id"
          :displayLabel="false"
          size="sm"
          :model.sync="selectedValueLocal"
          :disabled="isSelectedValueDisabled"
      />
    </div>

  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import select2                  from '../../../input/Select2.vue'
import { capitalize }           from '../../../../utils/filter'
import i18n                     from '../../../../libs/i18n'
import useAPI                   from '../../../../utils/useAPI'

export default {
  components: { select2 },
  props: {
    sectionFilter: {
      type: Object,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },
  setup (props, { emit }) {
    console.log(props.sectionFilter)
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const operatorLocal = ref({
      value: props.sectionFilter.operator,
      i18n: capitalize(i18n.t(props.sectionFilter.operator))
    })

    const operatorList = ref([
      {
        value: 'equal',
        i18n: capitalize(i18n.t('equal'))
      },
      {
        value: 'not_equal',
        i18n: capitalize(i18n.t('not_equal'))
      },
      {
        value: 'is_empty',
        i18n: capitalize(i18n.t('is_empty'))
      },
      {
        value: 'is_not_empty',
        i18n: capitalize(i18n.t('is_not_empty'))
      },
    ])

    const selectedValueLocal = ref(props.sectionFilter.value)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const {
      autocompleteEmployees
    } = useAPI()

    const isSelectedValueDisabled = computed(() => {
      if (
          props.isDisabled ||
          (
              operatorLocal.value != null &&
              (
                  operatorLocal.value.value == 'is_empty' ||
                  operatorLocal.value.value == 'is_not_empty'
              )
          ) || (
              ('_isInputValueDisabled' in props.sectionFilter) &&
              props.sectionFilter._isInputValueDisabled == true
          )
      ) {
        return true
      } else {
        return false
      }
    })

    const isOperatorDisabled = computed(() => {
      return props.isDisabled || ('_operatorDisabled' in props.sectionFilter && props.sectionFilter._operatorDisabled == true)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(operatorLocal, val => {
      if (
          val != null &&
          (
              val.value == 'is_empty' ||
              val.value == 'is_not_empty'
          )) {
        selectedValueLocal.value = null
      }

      parentUpdate()
    })
    watch(selectedValueLocal, val => {
      parentUpdate()
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const parentUpdate = () => {
      if (!props.isDisabled) {
        if (['is_empty', 'is_not_empty'].includes(operatorLocal.value.value)) {
          emit('update:sectionFilter', {
            name: props.sectionFilter.name,
            logicOperator: props.sectionFilter.logicOperator,
            field: props.sectionFilter.field,
            operator: operatorLocal.value.value,
            subFields: props.sectionFilter.subFields,
            value: null
          })
        } else {
          emit('update:sectionFilter', {
            name: props.sectionFilter.name,
            logicOperator: props.sectionFilter.logicOperator,
            field: props.sectionFilter.field,
            operator: operatorLocal.value.value,
            subFields: props.sectionFilter.subFields,
            value: selectedValueLocal.value
          })
        }
      }
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data
      operatorLocal,
      operatorList,
      selectedValueLocal,

      // Computed
      isSelectedValueDisabled,
      autocompleteEmployees,
      isOperatorDisabled,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>